import React from "react";
import {Select} from "antd";
import {useTranslation} from "react-i18next";

const PoolIntegrationTypeFilter = ({value, onChange, disabled = false}) => {
    const {t} = useTranslation(["common"]);

    return (
        <Select
            value={value}
            onChange={onChange}
            disabled={disabled}
            style={{width: "100%"}}
            placeholder={t("filters.integrationType", {ns: "common"})}
        >
            <Select.Option value="">
                {t("filters.integrationTypes.all", {ns: "common"})}
            </Select.Option>
            <Select.Option value="dedicated">
                {t("filters.integrationTypes.dedicated", {ns: "common"})}
            </Select.Option>
            <Select.Option value="pool">
                {t("filters.integrationTypes.pool", {ns: "common"})}
            </Select.Option>
            <Select.Option value="dedicatedIntegration">
                {t("filters.integrationTypes.dedicatedIntegration", {ns: "common"})}
            </Select.Option>
        </Select>
    );
};

export default PoolIntegrationTypeFilter;
